<template>
  <section>
    <form action v-on:submit.prevent="editFolder">
      <div class="modal-card">
        <header class="modal-card-head">
          <p>Editar Carpeta</p>
        </header>
        <section class="modal-card-body">
          <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>
          <b-field label="Nombre de la carpeta" :label-position="'on-border'">
            <b-input v-model="folder.name" required></b-input>
          </b-field>
          <b-field label="Descripción" :label-position="'on-border'">
            <b-input
              v-model="folder.description"
              type="textarea"
              required
            ></b-input>
          </b-field>
        </section>
        <footer class="modal-card-foot">
          <button class="button" type="button" @click="$parent.close()">
            Cerrar
          </button>
          <button class="button is-primary" type="submit">Guardar</button>
        </footer>
      </div>
    </form>
  </section>
</template>
<script>
// import { putDirectory, getDirectory } from "../../../services/directory";
import { DirectoryService } from '../../../services/models/directory';

export default {
  props: ["id", "chargeListDirectory"],
  data() {
    return {
      folder: {
        name: "",
        description: "",
      },
      isLoading: false,
    };
  },
  mounted() {
    this.chargeData();
  },
  methods: {
    async chargeData() {
      this.isLoading = true;
      const {data : folder} = await DirectoryService.getById(this.id);
      this.folder = folder;
      // this.folder = await getDirectory(this.$http, this.id);
      this.isLoading = false;
    },
    async editFolder() {
      this.isLoading = true;
      let data = {
        ...this.folder,
      };
      DirectoryService.update(this.id, data)
      // await putDirectory(this.$http, this.id, data);
      this.isLoading = true;
      this.$buefy.notification.open({
        message: "Carpeta Editada!",
        type: "is-success",
      });
      this.chargeListDirectory();
      this.$parent.close();
    },
  },
};
</script>